<template lang="html">
  <v-content>
    <How />
    <Download />
    <Services />
    <Download />
    <Youtube />
    <Versions />
    <Vision2 />
    <Technology />
    <Metrics />
    <Team />
    <About />
    <Partners />
  </v-content>
</template>

<script>
import How from './How'
import Team from './Team'
import About from './About'
import Partners from './Partners'
import Technology from './Technology'
import Versions from './Versions'
import Vision2 from './Vision2'
import Testimonials from './Testimonials'
import Footer from './Footer'
import Download from './Download'
import Metrics from './Metrics'
import Gif from './Gif'
import Services from './Services'
import Youtube from './Youtube'
export default {
  components: {
    How,
    Services,
    Team,
    Versions,
    Technology,
    Gif,
    Vision2,
    Testimonials,
    About,
    Partners,
    Footer,
    Metrics,
    Youtube,
    Download
  }
}
</script>

<style lang="css" scoped></style>
